import React from "react";
import * as styles from "./registerStyles";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Label
} from "semantic-ui-react";
import { messages } from "../../../../utils";
import { FormInput } from "../../../common";
const { validation } = messages;

class Register extends React.Component {
  onSubmitBtnClick(values) {
    const { handleSubmitBtn } = this.props;
    handleSubmitBtn(values);
  }
  render() {
    const { isLoading, onLogin } = this.props;
    return (
      <div style={{ marginTop: "10px" }}>
        <Grid centered columns={2}>
          <Grid.Column>
            <Header as="h2" textAlign="center">
              Register
            </Header>
            <Segment>
              <Form>
                <Formik
                  initialValues={{
                    name: "",
                    email: "",
                    password: "",
                    confirmPassword: ""
                  }}
                  onSubmit={values => this.onSubmitBtnClick(values)}
                  validationSchema={Yup.object().shape({
                    name: Yup.string()
                      .min(2, "Name must be at least 3 characters")
                      .max(100, "Maximum characters exceed 100")
                      .required(validation.requiredField),
                    email: Yup.string()
                      .email(validation.invalidEmail)
                      .max(100, "Maximum characters exceed 100")
                      .required(validation.requiredField),
                    password: Yup.string()
                      .min(6, "Password must be at least 6 characters")
                      .max(100, "Maximum characters exceed 100")
                      .required(validation.requiredField),
                    confirmPassword: Yup.string()
                      .oneOf(
                        [Yup.ref("password"), null],
                        "Passwords must match"
                      )
                      .max(100, "Maximum characters exceed 100")
                      .required(validation.requiredField)
                  })}
                  render={({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched
                  }) => (
                    <div>
                      <div className="row">
                        <div className="col-sm">
                          {errors.name && touched.name && (
                            <Label>{errors.name}</Label>
                          )}
                          <FormInput
                            style={{ marginBottom: "10px" }}
                            value={values.name}
                            fluid
                            icon="user"
                            iconPosition="left"
                            placeholder="Name"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                            name="name"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm">
                          {errors.email && touched.email && (
                            <Label>{errors.email}</Label>
                          )}
                          <FormInput
                            style={{ marginBottom: "10px" }}
                            value={values.email}
                            fluid
                            icon="user"
                            iconPosition="left"
                            placeholder="Email address"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                            name="email"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm mt-4">
                          {errors.password && touched.password && (
                            <Label style={{ marginTop: "5px" }}>
                              {errors.password}
                            </Label>
                          )}
                          <FormInput
                            style={{ marginBottom: "10px" }}
                            fluid
                            value={values.password}
                            icon="lock"
                            iconPosition="left"
                            placeholder="Password"
                            type="password"
                            name="password"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm mt-4">
                          {errors.confirmPassword &&
                            touched.confirmPassword && (
                              <Label style={{ marginTop: "5px" }}>
                                {errors.confirmPassword}
                              </Label>
                            )}
                          <FormInput
                            style={{ marginBottom: "10px" }}
                            value={values.confirmPassword}
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Confirm Password"
                            type="password"
                            name="confirmPassword"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm text-right">
                          <Button
                            loading={isLoading}
                            color="blue"
                            type="submit"
                            fluid
                            size="large"
                            onClick={() => handleSubmit(values)}
                          >
                            Register
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                />
              </Form>
            </Segment>
            <Message>
              Already have account?{" "}
              <a href="#" onClick={onLogin}>
                Login
              </a>
            </Message>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Register;
